<template>
    <div class="index">
        <img class="bg" src="../../static/pcbg.jpg" alt="">
        <div class="title">
            <span>第三方授权平台</span>
        </div>
        <div class="title2">
            <span>Authorization platform</span>
        </div>
        <input v-model="orgCode" class="input" type="text" placeholder="请输入机构编码">
        <div @click="addCode" class="btn">
            <span>提 交</span>
        </div>
    </div>
</template>

<script>
    import { Toast } from 'vant';
    export default {
        name: "pc",
        data(){
            return {
                orgCode:'',
                code:'',
            }
        },
        mounted() {
            this.saveQrCodeAndCourse()
        },
        methods:{
            async saveQrCodeAndCourse(){
                var res = await this.$api.home.getWxPreAuthCode({});
                console.log(res.data);
                this.code = res.data.pre_auth_code
            },
            addCode(){
                var code  = this.code;
                if(!this.orgCode){
                    Toast.fail('请输入机构编码~');
                    return
                }
                var url = 'https://' + location.host;
                if(location.host.indexOf('localhost') != -1){
                    url = 'https://eistest.unishining.com'
                }
                var appid = 'wx470f0482e5681910';
                console.log('location.host',location.host);
                if(location.host == 'zxop.unishining.com'){
                    appid = 'wx734ec7e1eea7ba29';
                }
                window.location = "https://mp.weixin.qq.com/cgi-bin/componentloginpage?component_appid="+appid+"&pre_auth_code=" +  code +  "&redirect_uri=" + url +"/wechat/wechatToken/oauthCallBack?orgCode=" + this.orgCode
            }
        },

    }
</script>

<style scoped>
.title{
    font-size: 40px;
    font-weight: bold;
    color: #fff;
    margin-top: -130px;
}
.title2{
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 40px;
}
 .index{
     position: fixed;
     left: 0;
     top: 0;
     width: 100%;
     height: 100%;
     overflow: hidden;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
 }
.bg{
    position: fixed;
    left: 50%;
    top: 0;
    width: 1920px;
    filter: blur(10px);
    z-index: -1;
    margin-left: -960px;
}
.input{
    width: 400px;
    height: 45px;
    border: none;
    background: rgba(255,255,255,.5);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 20px;
    text-align: center;
    color: #fff;
    font-size: 20px;
}
.btn{
    margin-top: 20px;
    width: 150px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 5px;
    background: rgb(71, 108, 186);
    cursor: pointer;
}
</style>